export class OutfitsQuery {
  static get KEYS () {
    return {
      TEXT: 'text'
    };
  }
}
